import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "./logo";
import mystyle from "./appNav.module.css";
import { IoMdMenu } from "react-icons/io";
import LoggedIn from "./appNav/logedIn";
import { IoMdClose } from "react-icons/io";
import LoggedOut from "./appNav/loggedOut";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectUserType } from "../features/authSlice";

export default function AppNav() {
  const [show, setShow] = useState<boolean>(false);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userType = useSelector(selectUserType);
  return (
    <div className=" relative items-center  justify-between  px-4  min-w-full flex flex-wrap gap-4  lg:px-10   lg:justify-around py-4 bg-sky-100 ">
      <div className={`w-3/4 lg:w-auto `}>
        <Logo />
      </div>
      <div
        className={`  flex lg:hidden text-5xl absolute top-5 right-5  items-center cursor-pointer text-gray-700  `}
        onClick={() => setShow(!show)}
      >
        {show ? <IoMdClose /> : <IoMdMenu />}
      </div>
      <div
        className={`  ${
          show ? "flex-col space-y-4 p-3 " : "hidden"
        }   lg:flex lg:flex-row lg:justify-around lg:items-center w-[90%]  `}
      >
        <ul
          className={` ${mystyle.nav} text-sm lg:text-[11px] xl:text-sm  w-full flex-col   lg:flex lg:flex-row lg:justify-center space-x-0 space-y-4 lg:space-y-0 lg:space-x-10 items-center text-gray-400 font-semibold `}
        >
          {" "}
          <li>
            {" "}
            <NavLink className="hover:text-primary" to={"/"}>
              Home
            </NavLink>{" "}
          </li>
          {userType !== "client" && (
            <li>
              {" "}
              <NavLink className="hover:text-primary" to={"/professional"}>
                Professionals
              </NavLink>{" "}
            </li>
          )}
          {(userType === "tradie" || userType === "freeTradie") && (
            <li>
              {" "}
              <NavLink className="hover:text-primary" to={"/apprentice"}>
                Apprentices
              </NavLink>{" "}
            </li>
          )}
          <li>
            <NavLink className="hover:text-primary" to={"/service"}>
              Services
            </NavLink>
          </li>
          {userType && (userType === "tradie" || userType === "freeTradie") && (
            <li>
              <NavLink className="hover:text-primary" to={"/jobRequests"}>
                Job Requests
              </NavLink>
            </li>
          )}
          {userType && (
            <>
              {/* <li>
                {" "}
                <NavLink className="hover:text-primary" to={"/notifications"}>
                  Notifications
                </NavLink>{" "}
              </li>
              <li>
                <NavLink className="hover:text-primary" to={"/chats"}>
                  Chats
                </NavLink>{" "}
              </li> */}
              {(userType === "tradie" || userType === "client") && (
                <li>
                  <NavLink
                    className="hover:text-primary"
                    to={"/userJobHistory"}
                  >
                    My jobs
                  </NavLink>{" "}
                </li>
              )}
            </>
          )}
          <li>
            {" "}
            <NavLink className="hover:text-primary" to={"/contactUs"}>
              Contact Us
            </NavLink>{" "}
          </li>
        </ul>
        <div className="flex items-center justify-center gap-4  w-full  lg:w-4/12 ">
          {isAuthenticated ? <LoggedIn /> : <LoggedOut />}

          {/*  */}
        </div>
      </div>
    </div>
  );
}
